import { z } from "zod/mini";
import en from "zod/v4/locales/en.js";

z.config(en());
